
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Menu, X, ChevronDown, BookOpen, Briefcase, Flag, GraduationCap, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  return (
    <nav className="w-full py-4 bg-white/90 backdrop-blur-sm sticky top-0 z-50 border-b border-gray-100">
      <div className="container mx-auto flex items-center justify-between">
        <a href="/" className="flex items-center space-x-2">
          <div className="w-8 h-8 rounded-full bg-black flex items-center justify-center text-white font-bold text-xs">
            <Globe className="w-4 h-4" />
          </div>
          <span className="font-bold text-xl">visanow.io</span>
        </a>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8">
          <Link to="/visa-sponsored-jobs" className="text-gray-700 hover:text-black transition-colors font-medium flex items-center">
            <Briefcase className="mr-2 h-4 w-4" />
            Jobs
          </Link>
          
          <Link to="/visa-travel-guides" className="text-gray-700 hover:text-black transition-colors font-medium flex items-center">
            <Flag className="mr-2 h-4 w-4" />
            Visas
          </Link>
          
          <Link to="/scholarships" className="text-gray-700 hover:text-black transition-colors font-medium flex items-center">
            <GraduationCap className="mr-2 h-4 w-4" />
            Scholarships
          </Link>
          
          <Link to="/blog" className="text-gray-700 hover:text-black transition-colors font-medium flex items-center">
            <BookOpen className="mr-2 h-4 w-4" />
            Blog
          </Link>
        </div>
        
        <div className="hidden md:flex items-center space-x-4">
          <Link to="/tools">
            <Button size="sm" className="bg-black hover:bg-black/90 text-white">Get Started</Button>
          </Link>
        </div>
        
        {/* Mobile menu button */}
        <button 
          className="md:hidden text-gray-700" 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      
      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-gray-100 shadow-md z-50">
          <div className="container mx-auto py-4 flex flex-col space-y-4">
            <Link 
              to="/visa-sponsored-jobs" 
              className="text-gray-700 hover:text-black transition-colors font-medium px-4 py-2 flex items-center" 
              onClick={toggleMenu}
            >
              <Briefcase className="mr-2 h-4 w-4" />
              Jobs
            </Link>
            
            <Link 
              to="/visa-travel-guides" 
              className="text-gray-700 hover:text-black transition-colors font-medium px-4 py-2 flex items-center" 
              onClick={toggleMenu}
            >
              <Flag className="mr-2 h-4 w-4" />
              Visas
            </Link>
            
            <Link 
              to="/scholarships" 
              className="text-gray-700 hover:text-black transition-colors font-medium px-4 py-2 flex items-center" 
              onClick={toggleMenu}
            >
              <GraduationCap className="mr-2 h-4 w-4" />
              Scholarships
            </Link>
            
            <Link to="/blog" className="text-gray-700 hover:text-black transition-colors font-medium px-4 py-2 flex items-center" onClick={toggleMenu}>
              <BookOpen className="mr-2 h-4 w-4" />
              Blog
            </Link>
            
            <div className="flex flex-col space-y-2 px-4 pt-2 border-t border-gray-100">
              <Link to="/tools">
                <Button className="bg-black hover:bg-black/90 text-white w-full">Get Started</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
